import { UUID_V7_REGEX } from './chunk-EWGKAU72.js';
import { toBase64Url } from './chunk-LAMR6P2E.js';

// src/ids.ts
var lastMs = -1;
var counter = 0;
function random(n) {
  const out = new Uint8Array(n);
  globalThis.crypto.getRandomValues(out);
  return out;
}
function uuidv7FromParts(unixMs, rand) {
  if (!Number.isInteger(unixMs) || unixMs < 0 || unixMs > 281474976710655) {
    throw new RangeError("timestamp out of range");
  }
  if (rand.length < 10) throw new RangeError("need 10 random bytes");
  const b = new Uint8Array(16);
  let ms = unixMs;
  for (let i = 5; i >= 0; i--) {
    b[i] = ms % 256;
    ms = Math.floor(ms / 256);
  }
  b[6] = 112 | rand[0] & 15;
  b[7] = rand[1];
  b[8] = 128 | rand[2] & 63;
  b.set(rand.subarray(3, 10), 9);
  let hex = "";
  for (const x of b) hex += x.toString(16).padStart(2, "0");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
function uuidv7(now = Date.now()) {
  const rand = random(10);
  let ms = now;
  if (ms <= lastMs) {
    ms = lastMs;
    counter++;
    if (counter > 4095) {
      ms = ++lastMs;
      counter = 0;
    }
  } else {
    lastMs = ms;
    counter = (rand[0] << 8 | rand[1]) & 2047;
  }
  rand[0] = counter >> 8 & 15;
  rand[1] = counter & 255;
  return uuidv7FromParts(ms, rand);
}
function isUuidV7(value) {
  return typeof value === "string" && UUID_V7_REGEX.test(value);
}
function uuidv7Timestamp(id) {
  if (!isUuidV7(id)) throw new TypeError("not a UUIDv7");
  return parseInt(id.slice(0, 8) + id.slice(9, 13), 16);
}
function guestDeviceId() {
  return `guest:${toBase64Url(random(16))}`;
}

export { guestDeviceId, isUuidV7, uuidv7, uuidv7FromParts, uuidv7Timestamp };
//# sourceMappingURL=chunk-RPUENDSP.js.map
//# sourceMappingURL=chunk-RPUENDSP.js.map